<template>
  <div class="clubSingUpFinish">
    <finish-page button-caption="На главную" :exit-route="{name: 'HomePage'}">
      <template #mainText>
        Ваша заявка успешно отправлена!
      </template>
      <template #infoText>
        Срок рассмотрения заявки 14 рабочих дней. Результат будет виден в
        <a href="#"> личном кабинете сайта </a>,
        также Вы получите уведомление на электронную почту.
      </template>

    </finish-page>
  </div>
</template>

<script>
import FinishPage from "@/components/shared/FinishPage.vue";

export default {
  name: "ClubSignUpFinishView" ,
  components: {FinishPage}
}
</script>


<style scoped lang="scss">
.clubSingUpFinish {

}
</style>
